import * as yup from "yup";
import { getValidationSchema } from "@Shared/utils/validationSchema";
import { FormInputMeta } from '@Modules/core/types/FormMetaType';

// We can follow the exemple of this file /src/modules/admin/archiving/containers/formHandlers/atmTransactionInquiryDetails/ATMTransactionInquiryDetailsFormMeta.ts

export interface IMerchantConsultationDetailsFormMeta {
  
  bank: FormInputMeta;
  agency: FormInputMeta;
  identifier: FormInputMeta;
  parentGroup: FormInputMeta;
  category: FormInputMeta;
  solvency: FormInputMeta;
  promoter: FormInputMeta;  
  status: FormInputMeta;
  opposed: FormInputMeta;

  schema: any;
}

const MerchantConsultationDetailsFormMeta = {} as IMerchantConsultationDetailsFormMeta;


MerchantConsultationDetailsFormMeta.bank = {
  name: 'bank',
  label: 'Banque',
  type: "select",
  options:  [
    {
      label: 'Banque A',
      value: 'a'
    },
    {
      label: 'Banque B',
      value: 'b',
    },
    {
      label: 'Banque C',
      value: 'b',
    },
  ],
  validation: yup.string().required("Ce champ est requis"),
};
MerchantConsultationDetailsFormMeta.agency = {
  name: 'agency',
  label: 'Agence',
  type: "select",
  options:  [
    {
      label: 'Agence A',
      value: 'a'
    },
    {
      label: 'Agence B',
      value: 'b',
    },
    {
      label: 'Agence C',
      value: 'b',
    },
  ],
  validation: yup.string().required("Ce champ est requis"),
};
MerchantConsultationDetailsFormMeta.identifier = {
  name: 'identifier',
  type: 'text',
  label: 'ID',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
MerchantConsultationDetailsFormMeta.parentGroup = {
  name: 'parentGroup',
  label: 'Groupe parent',
  type: "select",
  options:  [
    {
      label: 'Groupe parent A',
      value: 'a'
    },
    {
      label: 'Groupe parent B',
      value: 'b',
    },
    {
      label: 'Groupe parent C',
      value: 'b',
    },
  ],
  validation: yup.string().required("Ce champ est requis"),
};
MerchantConsultationDetailsFormMeta.category = {
  name: 'category',
  label: 'Categorie',
  type: "select",
  options:  [
    {
      label: 'Categorie A',
      value: 'a'
    },
    {
      label: 'Categorie B',
      value: 'b',
    },
    {
      label: 'Categorie C',
      value: 'b',
    },
  ],
  validation: yup.string().required("Ce champ est requis"),
};
MerchantConsultationDetailsFormMeta.solvency = {
  name: 'solvency',
  label: 'Solvabilité"',
  type: "select",
  options:  [
    {
      label: 'Solvabilité A',
      value: 'a'
    },
    {
      label: 'Solvabilité B',
      value: 'b',
    },
    {
      label: 'Solvabilité C',
      value: 'b',
    },
  ],
  validation: yup.string().required("Ce champ est requis"),
};
MerchantConsultationDetailsFormMeta.promoter = {
  name: 'promoter',
  label: 'Promoteur',
  type: "select",
  options:  [
    {
      label: 'Promoteur A',
      value: 'a'
    },
    {
      label: 'Promoteur B',
      value: 'b',
    },
    {
      label: 'Promoteur C',
      value: 'b',
    },
  ],
  validation: yup.string().required("Ce champ est requis"),
};
MerchantConsultationDetailsFormMeta.status = {
  name: 'status',
  type: 'select',
  label: 'Statut',
  options:  [
    {
      label: 'Active',
      value: 'a'
    },
    {
      label: 'Inactive',
      value: 'i',
    },
  ],
  validation: yup.string().required("Ce champ est requis"),
};
MerchantConsultationDetailsFormMeta.opposed = {
  name: 'opposed',
  type: 'checkbox',
  label: 'Opposé',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};

MerchantConsultationDetailsFormMeta.schema = yup.object().shape(getValidationSchema(MerchantConsultationDetailsFormMeta));

export default MerchantConsultationDetailsFormMeta;